let rootSelector = state => state.focus;

export const setRootSelector = selector => {
  rootSelector = selector;
};

export const isSinkInFocus = state => rootSelector(state)?.sinkInFocus;
export const getLastUpdate = state => rootSelector(state)?.lastUpdate;
